import { defaultHttpClient } from '../../httpClient';
import { isNotNil } from '../../../utils';
import type { GetMumulLiveProfilePostsResponse } from './types';

/**
 * - 무물라이브 프로필 콘텐츠(포스트) 목록 조회 API
 */
export const getMumulLiveProfilePosts = (
  profileSno: number,
  nextToken?: string | null,
) => {
  return defaultHttpClient
    .request<GetMumulLiveProfilePostsResponse>({
      method: 'GET',
      url: `/webview/mumul-live/profiles/${profileSno}/posts/`,
      params: isNotNil(nextToken) ? { next_token: nextToken } : undefined,
    })
    .then(r => r.data);
};
